export default __webpack_public_path__ + "static/media/tv_dark.cf87f1a9.png";